namespace TabAurous.Inventory {
    export namespace SKURepricingItemsService {
        export const baseUrl = 'Inventory/SKURepricingItems';

        export declare function Create(request: Serenity.SaveRequest<SKURepricingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SKURepricingItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SKURepricingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SKURepricingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetSKUDetails(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SKURepricingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetItemDetails(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SKURepricingItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/SKURepricingItems/Create",
            Update = "Inventory/SKURepricingItems/Update",
            Delete = "Inventory/SKURepricingItems/Delete",
            Retrieve = "Inventory/SKURepricingItems/Retrieve",
            List = "Inventory/SKURepricingItems/List",
            GetSKUDetails = "Inventory/SKURepricingItems/GetSKUDetails",
            GetItemDetails = "Inventory/SKURepricingItems/GetItemDetails"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetSKUDetails', 
            'GetItemDetails'
        ].forEach(x => {
            (<any>SKURepricingItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
